import Api from 'src/util/api';
export function all_data(params) {
    return Api.post('/monitor/hunan/cn_by/all_data/query', {
        ...params,
    });
}
export function get_water_collection_info(params) {
    return Api.post('/monitor/hunan/get_water_collection_info', {
        ...params,
    });
}
export function site_component(params) {
    return Api.post('/monitor/hunan/select/site_component', {
        ...params,
    });
}
